import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import VideoTemplate from './VideoTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export default class VideoComponent extends Rete.Component {
  constructor (config) {
    super(CONST_COMPONENT.VIDEO)

    this.data.component = VideoTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
  }

  builder (node) {
    node.lingualName = lingualName.VIDEO
    this.setConnection()

    const videoInput = new Rete.Input(CONST_SOCKET.VIDEO_INPUT, lang.video_socket_input_reply, this.socket.videoInput, true)
    const videoOutput = new Rete.Output(CONST_SOCKET.VIDEO_OUTPUT, lang.video_socket_output_next, this.socket.videoOutput, false)
    const videoOutputQuickreply = new Rete.Output(CONST_SOCKET.VIDEO_OUTPUT_QUICKREPLY, lang.video_socket_output_quick_replies, this.socket.videoOutputQuickreply, true)

    node.addInput(videoInput)
    node.addOutput(videoOutput)

    if (! instagram_addon) {
      node.addOutput(videoOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker (node, inputs, outputs) {
    outputs[CONST_SOCKET.VIDEO_OUTPUT] = node.data
  }

  setConnection() {
    // Video may be connected to:
    this.socket.videoOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.videoOutput.combineWith(this.socket.openaiInput)
    this.socket.videoOutput.combineWith(this.socket.carouselInput)
    this.socket.videoOutput.combineWith(this.socket.imageInput)
    this.socket.videoOutput.combineWith(this.socket.videoInput)
    this.socket.videoOutput.combineWith(this.socket.audioInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.videoOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.videoOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.videoOutput.combineWith(this.socket.fileInput)
      // this.socket.videoOutput.combineWith(this.socket.otnInput)
      if(this.isRcnAddonAvailable)
        this.socket.videoOutput.combineWith(this.socket.rcnInput)
    }
    
    this.socket.videoOutput.combineWith(this.socket.ecommerceInput)
    this.socket.videoOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.videoOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.videoOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (QuickReply): QuickReply
    this.socket.videoOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}